export default "__VITE_ASSET__D1$GhHk4__"